import { FC } from 'react'

import { RequestTypeAlias } from '@/api/models/requests/lib/requests.types'

type Props = {
  typeAlias: RequestTypeAlias
  description: string | null
  properties?: string[] | string
}

const ContentBlockProperties: FC<Props> = ({
  typeAlias,
  description,
  properties
}) => (
  <>
    {properties && typeAlias === RequestTypeAlias.PropertiesPass && (
      <div>
        <p className="mb-8 font-bold text-grey-90 text-16">Список имущества</p>
        <div className="whitespace-pre-line break-words font-pro text-16">
          {Array.isArray(properties) ? properties.join(', ') : properties}
        </div>
      </div>
    )}
    {description && typeAlias !== RequestTypeAlias.PropertiesPass && (
      <div>
        <p className="mb-4 font-bold text-grey-90 text-16">
          Что необходимо сделать
        </p>
        <div
          data-testid="request-description-id"
          className="whitespace-pre-line break-words font-pro text-16"
        >
          {description}
        </div>
      </div>
    )}
  </>
)

export default ContentBlockProperties
